var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useAppState } from "./use-app-state";
import { useEffect, useState } from "react";
import { useReady } from "./use-ready";
export var useActiveThemeMode = function () {
  var _a = __read(useAppState(), 3),
    appState = _a[0],
    setAppState = _a[1],
    patchAppState = _a[2];
  var _b = __read(useState(false), 2),
    isSystemDark = _b[0],
    setIsSystemDark = _b[1];
  var setTheme = function (mode) {
    patchAppState({
      themeMode: mode
    });
  };
  var isReady = useReady();
  var theme = appState.themeMode; // || getInitialTheme();
  // Listen for system theme changes
  useEffect(function () {
    var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    var handleSystemThemeChange = function (event) {
      setTheme(event.matches ? 'dark' : 'light');
    };
    // Add event listener for system mode change
    mediaQuery.addEventListener('change', handleSystemThemeChange);
    // Cleanup on component unmount
    return function () {
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
    };
  }, []);
  // Update the theme when localStorage changes (in the same or other tabs)
  useEffect(function () {
    var handleStorageChange = function (event) {
      if (event.key === 'theme') {
        setTheme(event.newValue || 'light');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    // Cleanup the event listener on unmount
    return function () {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  useEffect(function () {
    setIsSystemDark(window.matchMedia('(prefers-color-scheme: dark)').matches);
    if (isReady) {
      var savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        patchAppState({
          themeMode: savedTheme
        });
      }
    }
  }, [!!isReady]);
  // Apply the theme to the document body and store it in localStorage
  useEffect(function () {
    if (typeof localStorage !== 'undefined' && theme !== undefined) {
      setIsSystemDark(window.matchMedia('(prefers-color-scheme: dark)').matches);
      localStorage.setItem('theme', theme);
    }
  }, [theme]);
  var themeMode = appState.themeMode || 'light';
  return {
    themeMode: themeMode,
    isSystemDark: isSystemDark,
    isDark: themeMode === 'dark' || themeMode === 'system' && isSystemDark,
    setThemeMode: function (mode) {
      return setTheme(mode);
    }
  };
};